import styled from "styled-components";

export const ApplyButtonPortrait = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 6px 6.279px;
  gap: 8.97px;
  border: 1px solid transparent;
  background: ${({ backgroundColor }) => backgroundColor || "#e7e7e7"};
  color: ${({ color }) => color || "#000"};
  font-size: var(--fs-xs);
  font-weight: 500;
`;
